var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-1",style:(_vm.cssVariables)},[_c('div',{staticClass:"col-span-1 px-1 sm:px-8 md:px-24 lg:px-10 py-4 callout-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }